/**
 * Utility for adjusting dropdown positions to keep them within viewport bounds
 */

export interface DropdownDimensions {
  width: number
  height: number
}

export interface AdjustedPosition {
  x: number
  y: number
}

/**
 * Adjusts a dropdown position to keep it within viewport bounds
 * @param position - The initial position { x, y }
 * @param dimensions - The dropdown dimensions { width, height }
 * @param margin - Margin from viewport edges (default: 10)
 * @returns Adjusted position that keeps the dropdown within viewport
 */
export function adjustDropdownPosition(
  position: { x: number; y: number },
  dimensions: DropdownDimensions,
  margin: number = 10
): AdjustedPosition {
  const { width, height } = dimensions
  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight

  let adjustedX = position.x
  let adjustedY = position.y

  // Check right edge overflow
  if (adjustedX + width > viewportWidth - margin) {
    adjustedX = viewportWidth - width - margin
  }

  // Check left edge overflow
  if (adjustedX < margin) {
    adjustedX = margin
  }

  // Check bottom edge overflow
  if (adjustedY + height > viewportHeight - margin) {
    adjustedY = viewportHeight - height - margin
  }

  // Check top edge overflow
  if (adjustedY < margin) {
    adjustedY = margin
  }

  return { x: adjustedX, y: adjustedY }
}
